import React from 'react'
import { BackTop, Layout } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import TopBar from 'components/LayoutComponents/TopBar'
import Menu from 'components/LayoutComponents/Menu'
import Footer from 'components/LayoutComponents/Footer'
import Breadcrumbs from 'components/LayoutComponents/Breadcrumbs'
import Settings from 'components/LayoutComponents/Settings'

import { get } from 'utils'
import { NA_CHAR } from 'components/DashboardComponents/RevisionHistory/EntityHistory/utils'
import { FormattedMessage } from 'react-intl'

import './style.scss'

const mapStateToProps = ({ settings }) => ({
  isBorderless: settings.isBorderless,
  isSquaredBorders: settings.isSquaredBorders,
  isFixedWidth: settings.isFixedWidth,
  isMenuShadow: settings.isMenuShadow,
  isMenuTop: settings.isMenuTop,
})

@withRouter
@connect(mapStateToProps)
class Management extends React.PureComponent {
  render() {
    const {
      children,
      isBorderless,
      isSquaredBorders,
      isFixedWidth,
      isMenuShadow,
      isMenuTop,
      project,
    } = this.props

    const currentProjectName = get('company.name', project, NA_CHAR)

    return (
      <Layout
        className={classNames({
          settings__borderLess: isBorderless,
          settings__squaredBorders: isSquaredBorders,
          settings__fixedWidth: isFixedWidth,
          settings__menuShadow: isMenuShadow,
          settings__menuTop: isMenuTop,
        })}
      >
        <BackTop />
        <Menu
          customMenuData={[
            {
              title: <FormattedMessage id="menu.projectOverview" />,
              key: 'ProjectOverview',
              url: '/portfolio',
              icon: 'icmn icmn-briefcase',
            },
            {
              divider: true,
            },
            {
              title: (
                <FormattedMessage id="menu.backToProject" values={{ name: currentProjectName }} />
              ),
              key: 'BackToProject',
              url: '/overview',
              icon: 'icmn icmn-home',
            },
            {
              divider: true,
            },
          ]}
        />
        <Settings />
        <Layout>
          <Layout.Header>
            <TopBar />
          </Layout.Header>
          <Layout.Content className="layout-content">
            <Breadcrumbs />
            <div className="utils__content">{children}</div>
          </Layout.Content>
          <Layout.Footer>
            <Footer />
          </Layout.Footer>
        </Layout>
      </Layout>
    )
  }
}

export default Management
